import { db } from './firebase';
import { doc, getDoc, collection, getDocs } from 'firebase/firestore';

export const geolocationService = {
  // Obtener configuración de geocerca por defecto o fallback
  async getGeofenceConfig() {
    try {
      const docRef = doc(db, 'configuracion', 'geocerca');
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        return { id: 'default', nombre: 'Oficina Central', ...docSnap.data() };
      }
      return {
        id: 'default',
        nombre: 'Oficina Principal',
        latitude: 25.6261424,
        longitude: -100.2739912,
        radius: 100
      };
    } catch (error) {
      console.error('Error al obtener geocerca:', error);
      return {
        id: 'default',
        nombre: 'Oficina Principal',
        latitude: 25.6261424,
        longitude: -100.2739912,
        radius: 100
      };
    }
  },

  getCurrentPosition() {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error('Geolocalización no soportada por este dispositivo o navegador'));
        return;
      }
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            accuracy: position.coords.accuracy
          });
        },
        (error) => {
          let errorMsg = 'Error al obtener ubicación';
          if (error.code === 1) errorMsg = 'Permiso de ubicación denegado. Por favor actívalo en tu navegador o dispositivo.';
          else if (error.code === 2) errorMsg = 'Ubicación no disponible. Verifica que tu GPS esté encendido.';
          else if (error.code === 3) errorMsg = 'Tiempo de espera agotado al consultar GPS.';
          reject(new Error(errorMsg));
        },
        { enableHighAccuracy: true, timeout: 12000, maximumAge: 30000 }
      );
    });
  },

  calculateDistance(lat1, lon1, lat2, lon2) {
    const R = 6371e3; // Radio de la Tierra en metros
    const φ1 = (lat1 * Math.PI) / 180;
    const φ2 = (lat2 * Math.PI) / 180;
    const Δφ = ((lat2 - lat1) * Math.PI) / 180;
    const Δλ = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  },

  async isWithinGeofence(userSucursalId = null) {
    try {
      const position = await this.getCurrentPosition();
      let targetLocations = [];

      // 1. Si el usuario tiene una sucursal asignada específica
      if (userSucursalId) {
        try {
          const sucDoc = await getDoc(doc(db, 'sucursales', userSucursalId));
          if (sucDoc.exists()) {
            targetLocations.push({ id: sucDoc.id, ...sucDoc.data() });
          }
        } catch (e) {
          console.warn('No se pudo cargar la sucursal asignada:', e);
        }
      }

      // 2. Si no tiene sucursal o no se encontró, consultar todas las sucursales
      if (targetLocations.length === 0) {
        try {
          const snapshot = await getDocs(collection(db, 'sucursales'));
          targetLocations = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
        } catch (e) {
          console.warn('Error al cargar sucursales:', e);
        }
      }

      // 3. Si aún no hay sucursales registradas, usar la configuración global
      if (targetLocations.length === 0) {
        const defaultConfig = await this.getGeofenceConfig();
        if (defaultConfig) {
          targetLocations.push(defaultConfig);
        }
      }

      if (targetLocations.length === 0) {
        return { withinGeofence: false, error: 'No hay sucursales ni geocercas configuradas' };
      }

      // 4. Evaluar proximidad con las ubicaciones autorizadas
      let closestLocation = null;
      let minDistance = Infinity;
      let isWithin = false;

      for (const loc of targetLocations) {
        if (!loc.latitude || !loc.longitude) continue;
        const dist = this.calculateDistance(
          position.latitude,
          position.longitude,
          parseFloat(loc.latitude),
          parseFloat(loc.longitude)
        );
        const radius = parseFloat(loc.radius) || 100;

        if (dist < minDistance) {
          minDistance = dist;
          closestLocation = loc;
        }

        if (dist <= radius) {
          isWithin = true;
          closestLocation = loc;
          minDistance = dist;
          break;
        }
      }

      return {
        withinGeofence: isWithin,
        distance: Math.round(minDistance),
        sucursalNombre: closestLocation?.nombre || 'Sucursal',
        position,
        config: closestLocation
      };
    } catch (error) {
      return { withinGeofence: false, error: error.message };
    }
  }
};